export const GUIDE_TYPES = {
  web_client: {
    value: "web_client",
    label: "Wizard",
    description: "Prompts are shown in order, one after the other, in one session",
  },
  ordered: {
    value: "ordered",
    label: "Journey",
    description: "Prompts are shown in order over time (across visits, events, or devices)",
  },
  unordered: {
    value: "unordered",
    label: "Triggered",
    description: "Prompt are shown in the order they are triggered",
  },
  survey: {
    value: "survey",
    label: "Survey",
    description: "A multiple-choice prompt, followed by other prompts based on the selection",
  },
  tour: {
    value: "tour",
    label: "Tour",
    description: "Prompts are shown in order, but can be navigated back and forth",
  },
};
